<template>
  <div :class="[containerClass]">
    <label v-if="label" :id="`input-${name}-label`" :for="`input${name}`" :class="[labelClass || 'form-label fs-6 ', {isRequired: 'required'}]">
      {{ label }} <span v-if="isRequired" class="text-danger"> * </span>
    </label>
    <div :class="[
              { 'position-relative': (type === 'password') },
              IsInputGroup ? 'input-group' : ''
              ]">
      <input
          ref="selector"
          type="file"
          class="form-control"
          :class="[getClasses(size), inputClass]"
          :name="name"
          :id="`input-${name}`"
          :placeholder="placeholder"
          :required="isRequired"
          :aria-label="label"
          :aria-describedby="`input-${name}-addon`"
          :disabled="isDisabled"
          v-on:change="handleUpload()"
      />
      <span v-show="iconDir === 'right'" :id="`input-${name}-addon`" class="input-group-text" :class="addonClass">
       {{ iconText }}
        <i :class="getIcon(icon)"></i>
      </span>
    </div>
  </div>
</template>

<script setup>

import { ref, defineModel, defineProps } from 'vue'

const model = defineModel()

const props = defineProps( {
  size: {
    type: String,
    default: "default",
  },
  icon: String,
  iconDir: String,
  name: String,
  id: String,
  placeholder: String,
  isRequired: Boolean,
  inputClass: String,
  labelClass: String,
  containerClass: {
    type: String,
    default: 'col-12 mb-10'
  },
  label: String,
  isDisabled: Boolean,
  iconText: String,
  IsInputGroup: Boolean,
  addonClass: String
})

const selector = ref(null)


async function handleUpload () {
  model.value = selector?.value.files[0]
}


function getClasses (size) {
  let sizeValue;
  sizeValue = size ? `form-control-${size}` : null;
  return `${sizeValue}`;
}
function getIcon (icon) {
  return icon ? icon : null
}



</script>

<style scoped>

</style>
